<template>
  <a-form-model
    label-position="top"
    ref="form"
    :model="form"
    :rules="rules"
    :validate-on-rule-change="false"
  >
    <a-row>
      <a-col
        :xl="8"
        :lg="12"
        :md="24"
        :sm="24"
        :xs="24"
        v-for="(item, index) in formModel"
        :key="index"
      >
        <a-form-model-item :label="item.label" :prop="item.key">
          <a-input
            v-if="item.type === 'input'"
            v-model="form[item.key]"
            :placeholder="item.placeholder"
            style="width: 250px"
          />
          <a-select
            allowClear
            show-search
            option-filter-prop="children"
            v-else-if="item.type === 'select'"
            v-model="form[item.key]"
            :placeholder="item.placeholder"
            style="width: 250px"
          >
            <a-select-option
              v-for="selectOption in item.selectList"
              :value="selectOption.id"
              :key="selectOption.id"
              :label="selectOption.name"
            >
              {{ selectOption.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-col>
    </a-row>
  </a-form-model>
</template>

<script>
const isFalse = value => {
  if (typeof value === 'boolean' && value === false) return false
  return !value
}
export default {
  data() {
    return {
      isFalse,
      form: {},
      rules: {},
    }
  },
  props: {
    formModel: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    formModel: {
      deep: true,
      immediate: true,
      handler(newValue) {
        newValue.forEach(item => {
          this.$set(
            this.form,
            item.key,
            this.isFalse(item.defaultValue) ? '' : item.defaultValue,
          )
          if (item.rule) this.rules[item.key] = item.rule
        })
      },
    },
  },
  methods: {
    getFormData() {
      return { ...this.form }
    },
    validateForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (valid) {
            resolve({ ...this.form })
          }
          resolve(null)
        })
      })
    },
  },
}
</script>
